import { Component } from '@angular/core';
import { Platform } from '@ionic/angular';
import { AuthService } from './services/auth';
import { AppUpdateService } from './services/update.service';
import { StatusBar, Style } from '@capacitor/status-bar';
import { SplashScreen } from '@capacitor/splash-screen';
import { Capacitor } from "@capacitor/core";
import { AuthCleanupService } from "./services/axios/auth-cleanup.service";
import { setOn401Handler } from "./services/axios/axiosInstance";

@Component({
    selector: 'app-root',
    templateUrl: 'app.component.html',
    styleUrls: ['app.component.scss'],
    standalone: false
})
export class AppComponent {
    constructor(
        private platform: Platform,
        private auth: AuthService,
        private appUpdateService: AppUpdateService,
        private authCleanup: AuthCleanupService
    ) {
        setOn401Handler(() => this.authCleanup.handle401());

        this.initializeApp();
    }

  async initializeApp() {
    await this.platform.ready();

      if (Capacitor.isNativePlatform()) {
          try {
              await StatusBar.setStyle({ style: Style.Default });
              await SplashScreen.hide();
          } catch (error) {
              console.log('Native plugins not available:', error);
          }
      }
  }
}